export default "__VITE_ASSET__04878d77__"